import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'

import { createPinia } from 'pinia'
import { errorWatcherPlugin } from './stores/plugins/error-watcher-plugin'

import Skeleton from '@brayamvalero/vue3-skeleton'
import '@brayamvalero/vue3-skeleton/dist/style.css'
import globalHelpers from '@/helpers/global-helpers'
import i18n from './i18n'

import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'swiper/swiper-bundle.css'

import LoadingSpinner from '@/components/shared/LoadingSpinner.vue'
import {
  PulsModal,
  PulsFormCheck,
  PulsFormSelect,
  PulsFormRadio,
  PulsListGroup,
  PulsFormInput,
  PulsFormSwitch,
  PulsBackground,
  ThemeSelector
} from '@puls-solutions/puls-ui-components-vue3'
import '@puls-solutions/puls-ui-components-vue3/dist/puls-ui-components-vue3.css'
import '@puls-solutions/puls-good-html/theme/dist/assets/css/style.bundle.css'
import '@puls-solutions/puls-shared-menu-vue3/dist/puls-shared-menu-vue3.css'
import 'vue-multiselect/dist/vue-multiselect.css'

// Setup router, store, globals
export const pinia = createPinia()
pinia.use(errorWatcherPlugin)

const app = createApp(App)

// Register global components
app.component('LoadingSpinner', LoadingSpinner)
app.component('PulsBackground', PulsBackground)
app.component('PulsFormCheck', PulsFormCheck)
app.component('PulsFormInput', PulsFormInput)
app.component('PulsFormRadio', PulsFormRadio)
app.component('PulsFormSelect', PulsFormSelect)
app.component('PulsFormSwitch', PulsFormSwitch)
app.component('PulsListGroup', PulsListGroup)
app.component('PulsModal', PulsModal)
app.component('ThemeSelector', ThemeSelector)

// app use
app.use(pinia)
app.use(Skeleton)
app.use(i18n)
app.use(globalHelpers, i18n)
app.use(router)

app.mount('#app')
